import React, {type CSSProperties} from 'react';
import {Tooltip as RBTooltip} from 'react-bootstrap';

type Props = {
    id?: string;
    className?: string;
    style?: CSSProperties;
    children?: React.ReactNode;
    positionLeft?: number;
    placement?: string;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

export default function Tooltip(props: Props) {
    return (
        <RBTooltip
            id={props.id}
            className={props.className}
            positionLeft={props.positionLeft}
            style={props.style}
            placement={props.placement}
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
        >
            {props.children}
        </RBTooltip>
    );
}
